"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GeometryType = _interopRequireDefault(require("./GeometryType.js"));

var _SimpleGeometry = _interopRequireDefault(require("./SimpleGeometry.js"));

var _extent = require("../extent.js");

var _deflate = require("./flat/deflate.js");

var _math = require("../math.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/Point
 */


/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */
var Point =
/** @class */
function (_super) {
  __extends(Point, _super);
  /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   */


  function Point(coordinates, opt_layout) {
    var _this = _super.call(this) || this;

    _this.setCoordinates(coordinates, opt_layout);

    return _this;
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   */


  Point.prototype.clone = function () {
    var point = new Point(this.flatCoordinates.slice(), this.layout);
    point.applyProperties(this);
    return point;
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */


  Point.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
    var flatCoordinates = this.flatCoordinates;
    var squaredDistance = (0, _math.squaredDistance)(x, y, flatCoordinates[0], flatCoordinates[1]);

    if (squaredDistance < minSquaredDistance) {
      var stride = this.stride;

      for (var i = 0; i < stride; ++i) {
        closestPoint[i] = flatCoordinates[i];
      }

      closestPoint.length = stride;
      return squaredDistance;
    } else {
      return minSquaredDistance;
    }
  };
  /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   */


  Point.prototype.getCoordinates = function () {
    return !this.flatCoordinates ? [] : this.flatCoordinates.slice();
  };
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */


  Point.prototype.computeExtent = function (extent) {
    return (0, _extent.createOrUpdateFromCoordinate)(this.flatCoordinates, extent);
  };
  /**
   * Get the type of this geometry.
   * @return {import("./GeometryType.js").default} Geometry type.
   * @api
   */


  Point.prototype.getType = function () {
    return _GeometryType["default"].POINT;
  };
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */


  Point.prototype.intersectsExtent = function (extent) {
    return (0, _extent.containsXY)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
  };
  /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @api
   */


  Point.prototype.setCoordinates = function (coordinates, opt_layout) {
    this.setLayout(opt_layout, coordinates, 0);

    if (!this.flatCoordinates) {
      this.flatCoordinates = [];
    }

    this.flatCoordinates.length = (0, _deflate.deflateCoordinate)(this.flatCoordinates, 0, coordinates, this.stride);
    this.changed();
  };

  return Point;
}(_SimpleGeometry["default"]);

var _default = Point;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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